export default __webpack_public_path__ + "static/media/sister-abai.57145722.jpg";